import {
  InfiniteScrollDataTable,
  DataTableSearch,
  Typography,
  Loading,
  Button,
} from '@ui/components';
import { Refresh } from '@ui/components/icons';
import { Trans } from 'react-i18next';
import { t } from 'i18next';

import { useInvoicingTable } from './use-invoicing-table';

export const InvoicingTable = () => {
  const {
    isTableConfigLoading,
    columnsLength,
    globalFilter,
    hasNextPage,
    isFetching,
    totalItems,
    isLoading,
    table,
    fetchNextPage,
    resetTable,
  } = useInvoicingTable({});

  return (
    <div className="bg-table-background rounded-lg overflow-hidden mb-8 flex flex-col">
      <div className="flex items-center px-4 py-3">
        <Typography variant="labelMediumMedium">
          {t('FILES_REPORTS.INVOICING.TABLE.TITLE', { count: totalItems })}
        </Typography>

        <div className="ml-auto flex items-center gap-4">
          <DataTableSearch
            placeholder={t('FILES_REPORTS.INVOICING.TABLE.SEARCH_PLACEHOLDER')}
            onChange={table.setGlobalFilter}
            value={globalFilter}
          />
          <Button
            onClick={() => resetTable()}
            isLoading={isLoading}
            disabled={isLoading}
            variant="tertiary"
            className="w-50"
            icon
            wide
          >
            <Refresh />
            {t('FILES_REPORTS.INVOICING.TABLE.REFRESH')}
          </Button>
        </div>
      </div>

      <Loading isLoading={isTableConfigLoading}>
        <InfiniteScrollDataTable
          noResultsComponent={
            <Typography variant="labelMediumBook">
              <Trans i18nKey="FILES_REPORTS.INVOICING.TABLE.NO_RESULTS" />
            </Typography>
          }
          fetchNextPage={() => {
            fetchNextPage();
          }}
          columnsLength={columnsLength}
          className="flex-1 h-full"
          isFetching={isFetching}
          hasMore={hasNextPage}
          isLoading={isLoading}
          table={table}
        />
      </Loading>
    </div>
  );
};
